var _path, _g, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 199,
    viewBox: "0 0 148 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6973_5205)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6973_5205",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 52,
    y: 0,
    width: 45,
    height: 158
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.2288 -2.95237e-06L64.6412 -2.82889e-06L64.6412 132.894C64.6412 133.527 64.5424 134.398 64.3446 134.82C63.935 135.706 61.8023 135.734 61.7881 135.734L54.3305 135.734C54.1751 135.734 54.0339 135.734 53.9068 135.734C53.9915 135.846 54.0904 135.959 54.1893 136.057L73.2429 155.47C73.5819 155.821 73.9633 156.116 74.1751 156.243C74.4294 156.13 74.952 155.793 75.2627 155.484L94.7966 136.043C94.8955 135.945 94.9944 135.846 95.0791 135.748C94.952 135.748 94.8107 135.734 94.6695 135.734L87.2119 135.734C86.5763 135.734 85.7147 135.635 85.2768 135.439C84.3729 135.031 84.3588 132.908 84.3588 132.894L84.3588 -1.10513e-06L85.7712 -9.81654e-07L85.7712 132.894C85.7712 133.33 85.8983 133.935 85.9972 134.202C86.2373 134.258 86.7034 134.328 87.2119 134.328L94.6695 134.328C95.065 134.328 96.4068 134.37 96.7881 134.933L97 135.228L96.887 135.635C96.7034 136.127 95.8842 136.957 95.7994 137.041L76.2514 156.482C76.2514 156.482 74.7119 158 73.7797 157.635C73.3418 157.466 72.678 156.918 72.226 156.468L53.1723 137.055C52.9746 136.858 51.9859 135.804 52.113 135.115L52.1836 134.764L52.5508 134.567C53.0311 134.342 54.2034 134.342 54.3305 134.342L61.7881 134.342C62.226 134.342 62.8333 134.216 63.1017 134.117C63.1582 133.878 63.2288 133.4 63.2288 132.908L63.2288 0.0140657L63.2288 -2.95237e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6973_5205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52 0.126507L97 0.126511L97 -7.40588e-06L52 -1.13399e-05L52 0.126507Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 0.745006L97 0.74501L97 0.126512L52 0.126508L52 0.745006Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 1.36352L97 1.36353L97 0.745017L52 0.745013L52 1.36352Z",
    fill: "#FAFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 1.98204L97 1.98204L97 1.36353L52 1.36353L52 1.98204Z",
    fill: "#F9F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 2.60052L97 2.60052L97 1.98203L52 1.98202L52 2.60052Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 3.21904L97 3.21904L97 2.60053L52 2.60053L52 3.21904Z",
    fill: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 3.83755L97 3.83755L97 3.21905L52 3.21904L52 3.83755Z",
    fill: "#F6F6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 4.442L97 4.442L97 3.82349L52 3.82349L52 4.442Z",
    fill: "#F5F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 5.0605L97 5.0605L97 4.442L52 4.442L52 5.0605Z",
    fill: "#F4F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 5.679L97 5.679L97 5.06049L52 5.06049L52 5.679Z",
    fill: "#F3F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 6.29751L97 6.29752L97 5.67901L52 5.679L52 6.29751Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 6.91601L97 6.91602L97 6.29752L52 6.29751L52 6.91601Z",
    fill: "#F2F2F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 7.53451L97 7.53452L97 6.91601L52 6.916L52 7.53451Z",
    fill: "#F1F1F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 8.15303L97 8.15303L97 7.53452L52 7.53452L52 8.15303Z",
    fill: "#F0F0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 8.77153L97 8.77153L97 8.15303L52 8.15303L52 8.77153Z",
    fill: "#EFF0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 9.37597L97 9.37598L97 8.75748L52 8.75747L52 9.37597Z",
    fill: "#EEEFF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 9.99449L97 9.99449L97 9.37598L52 9.37598L52 9.99449Z",
    fill: "#EDEEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 10.613L97 10.613L97 9.99448L52 9.99448L52 10.613Z",
    fill: "#EDEDEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 11.2315L97 11.2315L97 10.613L52 10.613L52 11.2315Z",
    fill: "#ECECED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 11.85L97 11.85L97 11.2315L52 11.2315L52 11.85Z",
    fill: "#EBECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 12.4685L97 12.4685L97 11.85L52 11.85L52 12.4685Z",
    fill: "#EAEBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 13.087L97 13.087L97 12.4685L52 12.4685L52 13.087Z",
    fill: "#E9EAEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 13.7055L97 13.7055L97 13.087L52 13.087L52 13.7055Z",
    fill: "#E8E9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 14.31L97 14.31L97 13.6915L52 13.6915L52 14.31Z",
    fill: "#E8E8E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 14.9285L97 14.9285L97 14.31L52 14.31L52 14.9285Z",
    fill: "#E7E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 15.547L97 15.547L97 14.9285L52 14.9285L52 15.547Z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 16.1655L97 16.1655L97 15.547L52 15.547L52 16.1655Z",
    fill: "#E5E6E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 16.784L97 16.784L97 16.1655L52 16.1655L52 16.784Z",
    fill: "#E4E5E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 17.4025L97 17.4025L97 16.784L52 16.784L52 17.4025Z",
    fill: "#E3E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 18.021L97 18.021L97 17.4025L52 17.4025L52 18.021Z",
    fill: "#E2E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 18.6395L97 18.6395L97 18.021L52 18.021L52 18.6395Z",
    fill: "#E2E3E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 19.244L97 19.244L97 18.6254L52 18.6254L52 19.244Z",
    fill: "#E1E2E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 19.8625L97 19.8625L97 19.2439L52 19.2439L52 19.8625Z",
    fill: "#E0E1E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 20.481L97 20.481L97 19.8625L52 19.8625L52 20.481Z",
    fill: "#DFE0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 21.0995L97 21.0995L97 20.481L52 20.481L52 21.0995Z",
    fill: "#DEDFE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 21.718L97 21.718L97 21.0995L52 21.0995L52 21.718Z",
    fill: "#DDDFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 22.3365L97 22.3365L97 21.718L52 21.718L52 22.3365Z",
    fill: "#DDDEDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 22.955L97 22.955L97 22.3365L52 22.3365L52 22.955Z",
    fill: "#DCDDDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 23.5735L97 23.5735L97 22.955L52 22.955L52 23.5735Z",
    fill: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 24.1779L97 24.1779L97 23.5594L52 23.5594L52 24.1779Z",
    fill: "#DADBDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 24.7964L97 24.7964L97 24.1779L52 24.1779L52 24.7964Z",
    fill: "#D9DBDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 25.4149L97 25.4149L97 24.7964L52 24.7964L52 25.4149Z",
    fill: "#D9DADB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 26.0335L97 26.0335L97 25.415L52 25.4149L52 26.0335Z",
    fill: "#D8D9DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 26.652L97 26.652L97 26.0335L52 26.0335L52 26.652Z",
    fill: "#D7D8DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 27.2705L97 27.2705L97 26.652L52 26.6519L52 27.2705Z",
    fill: "#D6D7D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 27.889L97 27.889L97 27.2705L52 27.2705L52 27.889Z",
    fill: "#D5D7D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 28.5075L97 28.5075L97 27.889L52 27.889L52 28.5075Z",
    fill: "#D4D6D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 29.1119L97 29.1119L97 28.4934L52 28.4934L52 29.1119Z",
    fill: "#D4D5D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 29.7304L97 29.7304L97 29.1119L52 29.1119L52 29.7304Z",
    fill: "#D3D4D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 30.3489L97 30.3489L97 29.7304L52 29.7304L52 30.3489Z",
    fill: "#D2D3D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 30.9674L97 30.9674L97 30.3489L52 30.3489L52 30.9674Z",
    fill: "#D1D2D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 31.5859L97 31.5859L97 30.9674L52 30.9674L52 31.5859Z",
    fill: "#D0D2D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 32.2044L97 32.2045L97 31.5859L52 31.5859L52 32.2044Z",
    fill: "#CFD1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 32.8229L97 32.823L97 32.2045L52 32.2045L52 32.8229Z",
    fill: "#CFD0D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 33.4415L97 33.4415L97 32.823L52 32.8229L52 33.4415Z",
    fill: "#CECFD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 34.0459L97 34.0459L97 33.4274L52 33.4274L52 34.0459Z",
    fill: "#CDCED0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 34.6644L97 34.6644L97 34.0459L52 34.0459L52 34.6644Z",
    fill: "#CCCECF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 35.2829L97 35.2829L97 34.6644L52 34.6644L52 35.2829Z",
    fill: "#CBCDCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 35.9014L97 35.9014L97 35.2829L52 35.2829L52 35.9014Z",
    fill: "#CACCCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 36.5199L97 36.5199L97 35.9014L52 35.9014L52 36.5199Z",
    fill: "#C9CBCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 37.1384L97 37.1384L97 36.5199L52 36.5199L52 37.1384Z",
    fill: "#C9CACC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 37.7569L97 37.7569L97 37.1384L52 37.1384L52 37.7569Z",
    fill: "#C8CACB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 38.3754L97 38.3755L97 37.7569L52 37.7569L52 38.3754Z",
    fill: "#C7C9CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 38.9799L97 38.9799L97 38.3614L52 38.3614L52 38.9799Z",
    fill: "#C6C8CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 39.5984L97 39.5984L97 38.9799L52 38.9799L52 39.5984Z",
    fill: "#C5C7C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 40.2169L97 40.2169L97 39.5984L52 39.5984L52 40.2169Z",
    fill: "#C4C6C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 40.8354L97 40.8354L97 40.2169L52 40.2169L52 40.8354Z",
    fill: "#C4C5C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 41.4539L97 41.4539L97 40.8354L52 40.8354L52 41.4539Z",
    fill: "#C3C5C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 42.0724L97 42.0724L97 41.4539L52 41.4539L52 42.0724Z",
    fill: "#C2C4C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 42.6909L97 42.6909L97 42.0724L52 42.0724L52 42.6909Z",
    fill: "#C1C3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 43.3094L97 43.3094L97 42.6909L52 42.6909L52 43.3094Z",
    fill: "#C0C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 43.9139L97 43.9139L97 43.2954L52 43.2954L52 43.9139Z",
    fill: "#BFC1C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 44.5324L97 44.5324L97 43.9139L52 43.9139L52 44.5324Z",
    fill: "#BFC0C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 45.1509L97 45.1509L97 44.5324L52 44.5324L52 45.1509Z",
    fill: "#BEC0C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 45.7694L97 45.7694L97 45.1509L52 45.1509L52 45.7694Z",
    fill: "#BDBFC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 46.3879L97 46.3879L97 45.7694L52 45.7694L52 46.3879Z",
    fill: "#BCBEC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 47.0064L97 47.0064L97 46.3879L52 46.3879L52 47.0064Z",
    fill: "#BBBDBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 47.6249L97 47.6249L97 47.0064L52 47.0064L52 47.6249Z",
    fill: "#BABCBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 48.2434L97 48.2434L97 47.6249L52 47.6249L52 48.2434Z",
    fill: "#BABCBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 48.8479L97 48.8479L97 48.2294L52 48.2294L52 48.8479Z",
    fill: "#B9BBBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 49.4664L97 49.4664L97 48.8479L52 48.8479L52 49.4664Z",
    fill: "#B8BABC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 50.0849L97 50.0849L97 49.4664L52 49.4664L52 50.0849Z",
    fill: "#B7B9BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 50.7034L97 50.7034L97 50.0849L52 50.0849L52 50.7034Z",
    fill: "#B6B8BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 51.3219L97 51.3219L97 50.7034L52 50.7034L52 51.3219Z",
    fill: "#B5B7BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 51.9404L97 51.9404L97 51.3219L52 51.3219L52 51.9404Z",
    fill: "#B5B7B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 52.5589L97 52.5589L97 51.9404L52 51.9404L52 52.5589Z",
    fill: "#B4B6B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 53.1774L97 53.1774L97 52.5589L52 52.5589L52 53.1774Z",
    fill: "#B3B5B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 53.7818L97 53.7819L97 53.1633L52 53.1633L52 53.7818Z",
    fill: "#B2B4B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 54.4004L97 54.4004L97 53.7819L52 53.7818L52 54.4004Z",
    fill: "#B1B3B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 55.0189L97 55.0189L97 54.4004L52 54.4004L52 55.0189Z",
    fill: "#B0B3B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 55.6374L97 55.6374L97 55.0189L52 55.0189L52 55.6374Z",
    fill: "#B0B2B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 56.2559L97 56.2559L97 55.6374L52 55.6374L52 56.2559Z",
    fill: "#AFB1B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 56.8744L97 56.8744L97 56.2559L52 56.2559L52 56.8744Z",
    fill: "#AEB0B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 57.4929L97 57.4929L97 56.8744L52 56.8744L52 57.4929Z",
    fill: "#ADAFB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 58.1114L97 58.1114L97 57.4929L52 57.4929L52 58.1114Z",
    fill: "#ACAEB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 58.7158L97 58.7158L97 58.0973L52 58.0973L52 58.7158Z",
    fill: "#ACAEB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 59.3343L97 59.3343L97 58.7158L52 58.7158L52 59.3343Z",
    fill: "#ABADAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 59.9528L97 59.9529L97 59.3343L52 59.3343L52 59.9528Z",
    fill: "#AAACAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 60.5714L97 60.5714L97 59.9528L52 59.9528L52 60.5714Z",
    fill: "#A9ABAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 61.1899L97 61.1899L97 60.5714L52 60.5714L52 61.1899Z",
    fill: "#A8AAAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 61.8084L97 61.8084L97 61.1899L52 61.1899L52 61.8084Z",
    fill: "#A8AAAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 62.4269L97 62.4269L97 61.8084L52 61.8084L52 62.4269Z",
    fill: "#A7A9AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 63.0454L97 63.0454L97 62.4269L52 62.4269L52 63.0454Z",
    fill: "#A6A8AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 63.6498L97 63.6498L97 63.0313L52 63.0313L52 63.6498Z",
    fill: "#A5A7AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 64.2683L97 64.2683L97 63.6498L52 63.6498L52 64.2683Z",
    fill: "#A4A6A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 64.8868L97 64.8868L97 64.2683L52 64.2683L52 64.8868Z",
    fill: "#A4A6A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 65.5053L97 65.5053L97 64.8868L52 64.8868L52 65.5053Z",
    fill: "#A3A5A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 66.1238L97 66.1238L97 65.5053L52 65.5053L52 66.1238Z",
    fill: "#A2A4A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 66.7424L97 66.7424L97 66.1238L52 66.1238L52 66.7424Z",
    fill: "#A1A3A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 67.3608L97 67.3608L97 66.7423L52 66.7423L52 67.3608Z",
    fill: "#A0A3A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 67.9794L97 67.9794L97 67.3609L52 67.3608L52 67.9794Z",
    fill: "#A0A2A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 68.5838L97 68.5838L97 67.9653L52 67.9653L52 68.5838Z",
    fill: "#9FA1A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 69.2023L97 69.2023L97 68.5838L52 68.5838L52 69.2023Z",
    fill: "#9EA0A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 69.8208L97 69.8208L97 69.2023L52 69.2023L52 69.8208Z",
    fill: "#9D9FA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 70.4393L97 70.4393L97 69.8208L52 69.8208L52 70.4393Z",
    fill: "#9C9FA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 71.0578L97 71.0578L97 70.4393L52 70.4393L52 71.0578Z",
    fill: "#9C9EA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 71.6763L97 71.6763L97 71.0578L52 71.0578L52 71.6763Z",
    fill: "#9B9DA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 72.2948L97 72.2948L97 71.6763L52 71.6763L52 72.2948Z",
    fill: "#9A9C9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 72.9133L97 72.9133L97 72.2948L52 72.2948L52 72.9133Z",
    fill: "#999B9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 73.5178L97 73.5178L97 72.8993L52 72.8993L52 73.5178Z",
    fill: "#999B9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 74.1363L97 74.1363L97 73.5178L52 73.5178L52 74.1363Z",
    fill: "#989A9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 74.7548L97 74.7548L97 74.1363L52 74.1363L52 74.7548Z",
    fill: "#97999C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 75.3733L97 75.3733L97 74.7548L52 74.7548L52 75.3733Z",
    fill: "#96989B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 75.9918L97 75.9918L97 75.3733L52 75.3733L52 75.9918Z",
    fill: "#96989A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 76.6103L97 76.6103L97 75.9918L52 75.9918L52 76.6103Z",
    fill: "#959799"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 77.2288L97 77.2288L97 76.6103L52 76.6103L52 77.2288Z",
    fill: "#949699"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 77.8473L97 77.8473L97 77.2288L52 77.2288L52 77.8473Z",
    fill: "#939598"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 78.4518L97 78.4518L97 77.8333L52 77.8333L52 78.4518Z",
    fill: "#929597"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 79.0703L97 79.0703L97 78.4518L52 78.4518L52 79.0703Z",
    fill: "#929496"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 79.6888L97 79.6888L97 79.0703L52 79.0703L52 79.6888Z",
    fill: "#919396"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 80.3073L97 80.3073L97 79.6888L52 79.6888L52 80.3073Z",
    fill: "#909295"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 80.9258L97 80.9258L97 80.3073L52 80.3073L52 80.9258Z",
    fill: "#8F9194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 81.5443L97 81.5443L97 80.9258L52 80.9258L52 81.5443Z",
    fill: "#8F9193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 82.1628L97 82.1628L97 81.5443L52 81.5443L52 82.1628Z",
    fill: "#8E9093"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 82.7813L97 82.7813L97 82.1628L52 82.1628L52 82.7813Z",
    fill: "#8D8F92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 83.3858L97 83.3858L97 82.7673L52 82.7673L52 83.3858Z",
    fill: "#8C8E91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 84.0043L97 84.0043L97 83.3858L52 83.3858L52 84.0043Z",
    fill: "#8C8E90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 84.6228L97 84.6228L97 84.0043L52 84.0043L52 84.6228Z",
    fill: "#8B8D90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 85.2413L97 85.2413L97 84.6228L52 84.6228L52 85.2413Z",
    fill: "#8A8C8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 85.8598L97 85.8598L97 85.2413L52 85.2413L52 85.8598Z",
    fill: "#898B8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 86.4783L97 86.4783L97 85.8598L52 85.8598L52 86.4783Z",
    fill: "#898B8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 87.0968L97 87.0968L97 86.4783L52 86.4783L52 87.0968Z",
    fill: "#888A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 87.7153L97 87.7153L97 87.0968L52 87.0968L52 87.7153Z",
    fill: "#87898C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 88.3198L97 88.3198L97 87.7013L52 87.7012L52 88.3198Z",
    fill: "#86888B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 88.9383L97 88.9383L97 88.3198L52 88.3197L52 88.9383Z",
    fill: "#86888A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 89.5568L97 89.5568L97 88.9383L52 88.9383L52 89.5568Z",
    fill: "#85878A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 90.1753L97 90.1753L97 89.5568L52 89.5568L52 90.1753Z",
    fill: "#848689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 90.7938L97 90.7938L97 90.1753L52 90.1753L52 90.7938Z",
    fill: "#848588"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 91.4123L97 91.4123L97 90.7938L52 90.7938L52 91.4123Z",
    fill: "#838587"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 92.0308L97 92.0308L97 91.4123L52 91.4123L52 92.0308Z",
    fill: "#828486"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 92.6493L97 92.6493L97 92.0308L52 92.0308L52 92.6493Z",
    fill: "#818386"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 93.2678L97 93.2678L97 92.6493L52 92.6493L52 93.2678Z",
    fill: "#818285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 93.8722L97 93.8722L97 93.2537L52 93.2537L52 93.8722Z",
    fill: "#808284"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 94.4907L97 94.4908L97 93.8722L52 93.8722L52 94.4907Z",
    fill: "#7F8183"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 95.1092L97 95.1093L97 94.4907L52 94.4907L52 95.1092Z",
    fill: "#7E8083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 95.7278L97 95.7278L97 95.1093L52 95.1092L52 95.7278Z",
    fill: "#7E7F82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 96.3463L97 96.3463L97 95.7278L52 95.7278L52 96.3463Z",
    fill: "#7D7F81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 96.9648L97 96.9648L97 96.3463L52 96.3463L52 96.9648Z",
    fill: "#7C7E80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 97.5833L97 97.5833L97 96.9648L52 96.9648L52 97.5833Z",
    fill: "#7B7D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 98.2018L97 98.2018L97 97.5833L52 97.5833L52 98.2018Z",
    fill: "#7B7C7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 98.8062L97 98.8062L97 98.1877L52 98.1877L52 98.8062Z",
    fill: "#7A7C7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 99.4247L97 99.4247L97 98.8062L52 98.8062L52 99.4247Z",
    fill: "#797B7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 100.043L97 100.043L97 99.4247L52 99.4247L52 100.043Z",
    fill: "#787A7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 100.662L97 100.662L97 100.043L52 100.043L52 100.662Z",
    fill: "#78797C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 101.28L97 101.28L97 100.662L52 100.662L52 101.28Z",
    fill: "#77797B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 101.899L97 101.899L97 101.28L52 101.28L52 101.899Z",
    fill: "#76787A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 102.517L97 102.517L97 101.899L52 101.899L52 102.517Z",
    fill: "#75777A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 103.136L97 103.136L97 102.517L52 102.517L52 103.136Z",
    fill: "#757679"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 103.74L97 103.74L97 103.122L52 103.122L52 103.74Z",
    fill: "#747578"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 104.359L97 104.359L97 103.74L52 103.74L52 104.359Z",
    fill: "#737577"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 104.977L97 104.977L97 104.359L52 104.359L52 104.977Z",
    fill: "#727476"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 105.596L97 105.596L97 104.977L52 104.977L52 105.596Z",
    fill: "#727376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 106.214L97 106.214L97 105.596L52 105.596L52 106.214Z",
    fill: "#717275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 106.833L97 106.833L97 106.214L52 106.214L52 106.833Z",
    fill: "#707274"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 107.451L97 107.451L97 106.833L52 106.833L52 107.451Z",
    fill: "#6F7173"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 108.07L97 108.07L97 107.451L52 107.451L52 108.07Z",
    fill: "#6E7072"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 108.674L97 108.674L97 108.056L52 108.056L52 108.674Z",
    fill: "#6E6F72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 109.293L97 109.293L97 108.674L52 108.674L52 109.293Z",
    fill: "#6D6E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 109.911L97 109.911L97 109.293L52 109.293L52 109.911Z",
    fill: "#6C6E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 110.53L97 110.53L97 109.911L52 109.911L52 110.53Z",
    fill: "#6B6D6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 111.148L97 111.148L97 110.53L52 110.53L52 111.148Z",
    fill: "#6B6C6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 111.767L97 111.767L97 111.148L52 111.148L52 111.767Z",
    fill: "#6A6B6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 112.385L97 112.385L97 111.767L52 111.767L52 112.385Z",
    fill: "#696A6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 113.004L97 113.004L97 112.385L52 112.385L52 113.004Z",
    fill: "#68696C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 113.608L97 113.608L97 112.99L52 112.99L52 113.608Z",
    fill: "#67696B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 114.227L97 114.227L97 113.608L52 113.608L52 114.227Z",
    fill: "#67686A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 114.845L97 114.845L97 114.227L52 114.227L52 114.845Z",
    fill: "#666769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 115.464L97 115.464L97 114.845L52 114.845L52 115.464Z",
    fill: "#656668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 116.082L97 116.082L97 115.464L52 115.464L52 116.082Z",
    fill: "#646568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 116.701L97 116.701L97 116.082L52 116.082L52 116.701Z",
    fill: "#636467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 117.319L97 117.319L97 116.701L52 116.701L52 117.319Z",
    fill: "#626466"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 117.938L97 117.938L97 117.319L52 117.319L52 117.938Z",
    fill: "#626365"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 118.542L97 118.542L97 117.924L52 117.924L52 118.542Z",
    fill: "#616264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 119.161L97 119.161L97 118.542L52 118.542L52 119.161Z",
    fill: "#606163"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 119.779L97 119.779L97 119.161L52 119.161L52 119.779Z",
    fill: "#5F6062"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 120.398L97 120.398L97 119.779L52 119.779L52 120.398Z",
    fill: "#5E5F62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 121.016L97 121.016L97 120.398L52 120.398L52 121.016Z",
    fill: "#5D5E61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 121.635L97 121.635L97 121.016L52 121.016L52 121.635Z",
    fill: "#5D5E60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 122.253L97 122.253L97 121.635L52 121.635L52 122.253Z",
    fill: "#5C5D5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 122.872L97 122.872L97 122.253L52 122.253L52 122.872Z",
    fill: "#5B5C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 123.476L97 123.476L97 122.858L52 122.858L52 123.476Z",
    fill: "#5A5B5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 124.095L97 124.095L97 123.476L52 123.476L52 124.095Z",
    fill: "#595A5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 124.713L97 124.713L97 124.095L52 124.095L52 124.713Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 125.332L97 125.332L97 124.713L52 124.713L52 125.332Z",
    fill: "#57585A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 125.95L97 125.95L97 125.332L52 125.332L52 125.95Z",
    fill: "#575759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 126.569L97 126.569L97 125.95L52 125.95L52 126.569Z",
    fill: "#565658"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 127.187L97 127.187L97 126.569L52 126.569L52 127.187Z",
    fill: "#555558"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 127.806L97 127.806L97 127.187L52 127.187L52 127.806Z",
    fill: "#545457"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 128.41L97 128.41L97 127.792L52 127.792L52 128.41Z",
    fill: "#535456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 129.029L97 129.029L97 128.41L52 128.41L52 129.029Z",
    fill: "#525355"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 129.647L97 129.647L97 129.029L52 129.029L52 129.647Z",
    fill: "#515254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 130.266L97 130.266L97 129.647L52 129.647L52 130.266Z",
    fill: "#505153"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 130.884L97 130.884L97 130.266L52 130.266L52 130.884Z",
    fill: "#4F5052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 131.503L97 131.503L97 130.884L52 130.884L52 131.503Z",
    fill: "#4F4F51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 132.121L97 132.121L97 131.503L52 131.503L52 132.121Z",
    fill: "#4E4E50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 132.74L97 132.74L97 132.121L52 132.121L52 132.74Z",
    fill: "#4D4D4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 133.344L97 133.344L97 132.726L52 132.726L52 133.344Z",
    fill: "#4C4C4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 133.963L97 133.963L97 133.344L52 133.344L52 133.963Z",
    fill: "#4B4B4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 134.581L97 134.581L97 133.963L52 133.963L52 134.581Z",
    fill: "#4A4A4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 135.2L97 135.2L97 134.581L52 134.581L52 135.2Z",
    fill: "#49494B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 135.818L97 135.818L97 135.2L52 135.2L52 135.818Z",
    fill: "#48484A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 136.437L97 136.437L97 135.818L52 135.818L52 136.437Z",
    fill: "#474749"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 137.055L97 137.055L97 136.437L52 136.437L52 137.055Z",
    fill: "#464648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 137.674L97 137.674L97 137.055L52 137.055L52 137.674Z",
    fill: "#454547"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 138.278L97 138.278L97 137.66L52 137.66L52 138.278Z",
    fill: "#444446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 138.897L97 138.897L97 138.278L52 138.278L52 138.897Z",
    fill: "#434345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 139.515L97 139.515L97 138.897L52 138.897L52 139.515Z",
    fill: "#424244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 140.134L97 140.134L97 139.515L52 139.515L52 140.134Z",
    fill: "#414143"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 140.752L97 140.752L97 140.134L52 140.134L52 140.752Z",
    fill: "#404042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 141.371L97 141.371L97 140.752L52 140.752L52 141.371Z",
    fill: "#3F3F40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 141.989L97 141.989L97 141.371L52 141.371L52 141.989Z",
    fill: "#3E3E3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 142.608L97 142.608L97 141.989L52 141.989L52 142.608Z",
    fill: "#3D3D3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 143.212L97 143.212L97 142.594L52 142.594L52 143.212Z",
    fill: "#3C3B3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 143.831L97 143.831L97 143.212L52 143.212L52 143.831Z",
    fill: "#3B3A3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 144.449L97 144.449L97 143.831L52 143.831L52 144.449Z",
    fill: "#3A393B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 145.068L97 145.068L97 144.449L52 144.449L52 145.068Z",
    fill: "#393839"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 145.686L97 145.686L97 145.068L52 145.068L52 145.686Z",
    fill: "#383738"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 146.305L97 146.305L97 145.686L52 145.686L52 146.305Z",
    fill: "#373537"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 146.923L97 146.923L97 146.305L52 146.305L52 146.923Z",
    fill: "#363435"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 147.542L97 147.542L97 146.923L52 146.923L52 147.542Z",
    fill: "#343334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 148.146L97 148.146L97 147.528L52 147.528L52 148.146Z",
    fill: "#333233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 148.765L97 148.765L97 148.146L52 148.146L52 148.765Z",
    fill: "#323031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 149.383L97 149.383L97 148.765L52 148.765L52 149.383Z",
    fill: "#312F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 150.002L97 150.002L97 149.383L52 149.383L52 150.002Z",
    fill: "#302D2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 150.62L97 150.62L97 150.002L52 150.002L52 150.62Z",
    fill: "#2E2C2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 151.239L97 151.239L97 150.62L52 150.62L52 151.239Z",
    fill: "#2D2B2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 151.857L97 151.857L97 151.239L52 151.239L52 151.857Z",
    fill: "#2C292A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 152.476L97 152.476L97 151.857L52 151.857L52 152.476Z",
    fill: "#2B2829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 153.08L97 153.08L97 152.462L52 152.462L52 153.08Z",
    fill: "#292628"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 153.699L97 153.699L97 153.08L52 153.08L52 153.699Z",
    fill: "#282526"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 154.317L97 154.317L97 153.699L52 153.699L52 154.317Z",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 154.936L97 154.936L97 154.317L52 154.317L52 154.936Z",
    fill: "#262223"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 155.554L97 155.554L97 154.936L52 154.936L52 155.554Z",
    fill: "#242122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 156.173L97 156.173L97 155.554L52 155.554L52 156.173Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 158L97 158L97 156.173L52 156.173L52 158Z",
    fill: "#231F20"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5586 186L26.5586 176.006H27.7207L27.7207 184.947H32.1299V186H26.5586ZM40.1279 182.247C40.1279 183.468 39.8203 184.423 39.2051 185.111C38.5898 185.795 37.7399 186.137 36.6553 186.137C35.9854 186.137 35.3906 185.979 34.8711 185.665C34.3516 185.351 33.9505 184.899 33.668 184.312C33.3854 183.724 33.2441 183.035 33.2441 182.247C33.2441 181.026 33.5495 180.076 34.1602 179.396C34.7708 178.713 35.6185 178.371 36.7031 178.371C37.7513 178.371 38.583 178.72 39.1982 179.417C39.818 180.114 40.1279 181.058 40.1279 182.247ZM34.4199 182.247C34.4199 183.204 34.6113 183.933 34.9941 184.435C35.377 184.936 35.9398 185.187 36.6826 185.187C37.4255 185.187 37.9883 184.938 38.3711 184.441C38.7585 183.94 38.9521 183.209 38.9521 182.247C38.9521 181.295 38.7585 180.572 38.3711 180.08C37.9883 179.583 37.4209 179.335 36.6689 179.335C35.9261 179.335 35.3656 179.579 34.9873 180.066C34.609 180.554 34.4199 181.281 34.4199 182.247ZM48.2422 186L46.8682 181.604C46.7816 181.336 46.6198 180.725 46.3828 179.772H46.3281C46.1458 180.57 45.9863 181.185 45.8496 181.618L44.4346 186H43.1221L41.0781 178.508H42.2676C42.7507 180.39 43.1175 181.823 43.3682 182.808C43.6234 183.792 43.7692 184.455 43.8057 184.797H43.8604C43.9105 184.537 43.9902 184.202 44.0996 183.792C44.2135 183.377 44.3115 183.049 44.3936 182.808L45.7676 178.508H46.998L48.3379 182.808C48.5931 183.591 48.7663 184.25 48.8574 184.783H48.9121C48.9303 184.619 48.9782 184.366 49.0557 184.024C49.1377 183.683 49.6139 181.844 50.4844 178.508H51.6602L49.5889 186H48.2422ZM56.1855 186.137C55.0781 186.137 54.2031 185.799 53.5605 185.125C52.9225 184.451 52.6035 183.514 52.6035 182.315C52.6035 181.108 52.8997 180.148 53.4922 179.438C54.0892 178.727 54.889 178.371 55.8916 178.371C56.8304 178.371 57.5732 178.681 58.1201 179.301C58.667 179.916 58.9404 180.729 58.9404 181.741V182.459H53.7793C53.8021 183.339 54.0231 184.006 54.4424 184.462C54.8662 184.918 55.4609 185.146 56.2266 185.146C57.0332 185.146 57.8307 184.977 58.6191 184.64V185.651C58.2181 185.825 57.8376 185.948 57.4775 186.021C57.1221 186.098 56.6914 186.137 56.1855 186.137ZM55.8779 179.321C55.2764 179.321 54.7956 179.517 54.4355 179.909C54.0801 180.301 53.8704 180.843 53.8066 181.536H57.7236C57.7236 180.821 57.5641 180.274 57.2451 179.896C56.9261 179.513 56.4704 179.321 55.8779 179.321ZM64.2998 178.371C64.6325 178.371 64.931 178.398 65.1953 178.453L65.0381 179.506C64.7282 179.438 64.4548 179.403 64.2178 179.403C63.6117 179.403 63.0921 179.649 62.6592 180.142C62.2308 180.634 62.0166 181.247 62.0166 181.98V186H60.8818V178.508H61.8184L61.9482 179.896H62.0029C62.2809 179.408 62.6159 179.032 63.0078 178.768C63.3997 178.503 63.8304 178.371 64.2998 178.371ZM71.3682 186H70.2334V178.508H71.3682V186ZM70.1377 176.478C70.1377 176.218 70.2015 176.029 70.3291 175.91C70.4567 175.787 70.6162 175.726 70.8076 175.726C70.9899 175.726 71.1471 175.787 71.2793 175.91C71.4115 176.033 71.4775 176.222 71.4775 176.478C71.4775 176.733 71.4115 176.924 71.2793 177.052C71.1471 177.175 70.9899 177.236 70.8076 177.236C70.6162 177.236 70.4567 177.175 70.3291 177.052C70.2015 176.924 70.1377 176.733 70.1377 176.478ZM78.6074 183.956C78.6074 184.653 78.3477 185.191 77.8281 185.569C77.3086 185.948 76.5794 186.137 75.6406 186.137C74.6471 186.137 73.8724 185.979 73.3164 185.665V184.612C73.6764 184.795 74.0615 184.938 74.4717 185.043C74.8864 185.148 75.2852 185.2 75.668 185.2C76.2604 185.2 76.7161 185.107 77.0352 184.92C77.3542 184.729 77.5137 184.439 77.5137 184.052C77.5137 183.76 77.3861 183.512 77.1309 183.307C76.8802 183.097 76.388 182.851 75.6543 182.568C74.957 182.309 74.4603 182.083 74.1641 181.892C73.8724 181.696 73.6536 181.475 73.5078 181.229C73.3665 180.982 73.2959 180.688 73.2959 180.347C73.2959 179.736 73.5443 179.255 74.041 178.904C74.5378 178.549 75.2191 178.371 76.085 178.371C76.8916 178.371 77.68 178.535 78.4502 178.863L78.0469 179.786C77.2949 179.476 76.6136 179.321 76.0029 179.321C75.4652 179.321 75.0596 179.406 74.7861 179.574C74.5127 179.743 74.376 179.975 74.376 180.271C74.376 180.472 74.4261 180.643 74.5264 180.784C74.6312 180.925 74.7975 181.06 75.0254 181.188C75.2533 181.315 75.6908 181.5 76.3379 181.741C77.2266 182.065 77.8258 182.391 78.1357 182.719C78.4502 183.047 78.6074 183.459 78.6074 183.956ZM87.583 178.385C88.5674 178.385 89.3307 178.722 89.873 179.396C90.4199 180.066 90.6934 181.017 90.6934 182.247C90.6934 183.478 90.4176 184.435 89.8662 185.118C89.3193 185.797 88.5583 186.137 87.583 186.137C87.0954 186.137 86.6488 186.048 86.2432 185.87C85.8421 185.688 85.5049 185.41 85.2314 185.036H85.1494L84.9102 186H84.0967V175.363H85.2314V177.947C85.2314 178.526 85.2132 179.046 85.1768 179.506H85.2314C85.7601 178.758 86.5439 178.385 87.583 178.385ZM87.4189 179.335C86.6442 179.335 86.0859 179.558 85.7441 180.005C85.4023 180.447 85.2314 181.194 85.2314 182.247C85.2314 183.3 85.4069 184.054 85.7578 184.51C86.1087 184.961 86.6715 185.187 87.4463 185.187C88.1436 185.187 88.6631 184.934 89.0049 184.428C89.3467 183.917 89.5176 183.186 89.5176 182.233C89.5176 181.258 89.3467 180.531 89.0049 180.053C88.6631 179.574 88.1344 179.335 87.4189 179.335ZM95.8477 186.137C94.7402 186.137 93.8652 185.799 93.2227 185.125C92.5846 184.451 92.2656 183.514 92.2656 182.315C92.2656 181.108 92.5618 180.148 93.1543 179.438C93.7513 178.727 94.5511 178.371 95.5537 178.371C96.4925 178.371 97.2354 178.681 97.7822 179.301C98.3291 179.916 98.6025 180.729 98.6025 181.741V182.459L93.4414 182.459C93.4642 183.339 93.6852 184.006 94.1045 184.462C94.5283 184.918 95.123 185.146 95.8887 185.146C96.6953 185.146 97.4928 184.977 98.2812 184.64V185.651C97.8802 185.825 97.4997 185.948 97.1396 186.021C96.7842 186.098 96.3535 186.137 95.8477 186.137ZM95.54 179.321C94.9385 179.321 94.4577 179.517 94.0977 179.909C93.7422 180.301 93.5326 180.843 93.4688 181.536L97.3857 181.536C97.3857 180.821 97.2262 180.274 96.9072 179.896C96.5882 179.513 96.1325 179.321 95.54 179.321ZM102.964 185.2C103.164 185.2 103.358 185.187 103.545 185.159C103.732 185.127 103.88 185.095 103.989 185.063V185.932C103.866 185.991 103.684 186.039 103.442 186.075C103.205 186.116 102.991 186.137 102.8 186.137C101.351 186.137 100.626 185.373 100.626 183.847V179.39H99.5527V178.843L100.626 178.371L101.104 176.771H101.761V178.508H103.935V179.39H101.761V183.799C101.761 184.25 101.868 184.596 102.082 184.838C102.296 185.079 102.59 185.2 102.964 185.2ZM107.913 185.2C108.114 185.2 108.307 185.187 108.494 185.159C108.681 185.127 108.829 185.095 108.938 185.063V185.932C108.815 185.991 108.633 186.039 108.392 186.075C108.155 186.116 107.94 186.137 107.749 186.137C106.3 186.137 105.575 185.373 105.575 183.847V179.39H104.502V178.843L105.575 178.371L106.054 176.771H106.71V178.508H108.884V179.39H106.71V183.799C106.71 184.25 106.817 184.596 107.031 184.838C107.245 185.079 107.539 185.2 107.913 185.2ZM113.607 186.137C112.5 186.137 111.625 185.799 110.982 185.125C110.344 184.451 110.025 183.514 110.025 182.315C110.025 181.108 110.322 180.148 110.914 179.438C111.511 178.727 112.311 178.371 113.313 178.371C114.252 178.371 114.995 178.681 115.542 179.301C116.089 179.916 116.362 180.729 116.362 181.741V182.459H111.201C111.224 183.339 111.445 184.006 111.864 184.462C112.288 184.918 112.883 185.146 113.648 185.146C114.455 185.146 115.253 184.977 116.041 184.64V185.651C115.64 185.825 115.259 185.948 114.899 186.021C114.544 186.098 114.113 186.137 113.607 186.137ZM113.3 179.321C112.698 179.321 112.217 179.517 111.857 179.909C111.502 180.301 111.292 180.843 111.229 181.536H115.146C115.146 180.821 114.986 180.274 114.667 179.896C114.348 179.513 113.892 179.321 113.3 179.321ZM121.722 178.371C122.054 178.371 122.353 178.398 122.617 178.453L122.46 179.506C122.15 179.438 121.877 179.403 121.64 179.403C121.034 179.403 120.514 179.649 120.081 180.142C119.653 180.634 119.438 181.247 119.438 181.98V186H118.304V178.508H119.24L119.37 179.896H119.425C119.703 179.408 120.038 179.032 120.43 178.768C120.822 178.503 121.252 178.371 121.722 178.371Z",
    fill: "#231F20"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6973_5205"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 158,
    fill: "white",
    transform: "translate(97 158) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScore);
export default __webpack_public_path__ + "static/media/score.4a17f34f3c28ed09ee16cb241b5d44dc.svg";
export { ForwardRef as ReactComponent };